import {Grid, GridItem, VStack} from 'platform/foundation';

import {EntityResourceIds} from '@dms/api/shared';
import {testIds} from '@dms/routes';
import {CommentsWidget, NoteWidget, Section} from '@dms/shared';

type OverviewProps = {
  interestId: string;
};

export function Overview(props: OverviewProps) {
  return (
    <Section>
      <Grid columns={2}>
        <GridItem span={1}>
          <VStack spacing={4}>
            <CommentsWidget
              resourceId={EntityResourceIds.workshopInterest}
              recordId={props.interestId}
              data-testid={testIds.workshop.interestDetail('comments')}
            />
          </VStack>
        </GridItem>
        <GridItem span={1}>
          <NoteWidget
            isEditable
            resourceId={EntityResourceIds.workshopInterest}
            recordId={props.interestId}
            context={EntityResourceIds.workshopInterest}
            data-testid={testIds.workshop.interestDetail('note')}
          />
        </GridItem>
      </Grid>
    </Section>
  );
}
